const COUNTRIES_WITHOUT_STATE = ['gb', 'uk'];

function sync_state_with_country(country_select, states_parent, state_fields){
    const country_code = country_select.value?.toLowerCase() || '';
    const [state_input, state_us_select, state_ca_select] = state_fields;

    const state_form_group = states_parent.closest('.form-group');
    if (!state_form_group) return;

    if (COUNTRIES_WITHOUT_STATE.includes(country_code)) {
        state_form_group.style.display = 'none';
        state_form_group.querySelectorAll('input, select').forEach(el => {
            el.removeAttribute('required');
            el.value = '';
        });
        return;
    }

    state_form_group.style.display = '';

    Array.from(state_form_group.children).forEach(child => {
        if (!child.classList.contains('form-control-label')) {
            state_form_group.removeChild(child);
        }
    });

    if(country_code == 'us'){
        state_form_group.appendChild(state_us_select.cloneNode(true));
    }
    else if(country_code == 'ca'){
        state_form_group.appendChild(state_ca_select.cloneNode(true));
    }
    else {
        state_form_group.appendChild(state_input.cloneNode(true));
    }
}

/*
Old Version

function sync_state_with_country(country_select){
	const form = country_select.closest('form');
	const country_code = country_select.value?.toLowerCase() || '';
	const state_fields = form?.querySelectorAll('[name="billing_state"]');

	const hasCountryStatesSelect = country_code && [...state_fields].some(element => element.id && element.id.includes(`-${country_code}-`));

	state_fields?.forEach((el, index) => {
		if (hasCountryStatesSelect) {
			if (el.id.includes(`-${country_code}-`)) {
				el.disabled = false;
				el.style.display = '';
			} else {
				el.disabled = true;
				el.style.display = 'none';
			}
		} else {
			if (index === 0){
				el.disabled = false;
				el.style.display = '';
			} else {
				el.disabled = true;
				el.style.display = 'none';
			}
		}
	});
}
*/

function sync_zip_label_with_country(country_select, zip_field) {
    if (!zip_field) return;

    const country_code = country_select?.value?.toLowerCase() || '';
    const isUK = COUNTRIES_WITHOUT_STATE.includes(country_code);

    const labelZip = zip_field.dataset?.labelZip || 'Zip';
    const labelPostal = zip_field.dataset?.labelPostal || 'Postal Code';
    const placeholder = isUK ? labelPostal : labelZip;
    const requiredStar = zip_field.hasAttribute('required') ? ' *' : '';

    zip_field.placeholder = placeholder + requiredStar;
}

export {
	sync_state_with_country,
	sync_zip_label_with_country,
	COUNTRIES_WITHOUT_STATE
}
